import { LOCALES } from 'i18n/locales';

export const isolatedViewsIntl = {
    [LOCALES.ENGLISH]: {

        // networks
        'isolatedViews.networks.heading': 'Networks',
        'isolatedViews.networks.all': 'All',
        'isolatedViews.networks.hiddenAssets': 'Hidden assets',
        // -> all other networks come from map config
        'isolatedViews.networks.symbology.gas': 'Gas symbology',
        'isolatedViews.networks.symbology.electricity': 'Voltage colour coding',
        'isolatedViews.networks.tooltip': 'Apply network specific colour coding.',
        'isolatedViews.networks.legendButton': 'Open dynamic legend for colour descriptions',

        // annotations
        'isolatedViews.annotations.heading': 'Annotations',
        'isolatedViews.annotations.descriptions': 'Descriptions',
        'isolatedViews.annotations.dimensions': 'Dimensions',
        'isolatedViews.annotations.overlapping': 'Hide overlapping items',

        // maps
        'isolatedViews.maps.heading': 'Base map',
        'isolatedViews.maps.standard': 'Standard',
        'isolatedViews.maps.custom': 'Custom'
    },
    [LOCALES.WELSH]: {
        // networks
        'isolatedViews.networks.heading': '[Networks]',
        'isolatedViews.networks.all': '[All]',
        'isolatedViews.networks.hiddenAssets': '[Hidden assets]',
        // -> all other networks come from map config
        'isolatedViews.networks.symbology.gas': 'Symboleg nwy',
        'isolatedViews.networks.symbology.electricity': '[Voltage colour coding]',
        'isolatedViews.networks.tooltip': '[Apply network specific colour coding.]',
        'isolatedViews.networks.legendButton': '[Open dynamic legend for colour descriptions]',

        // annotations
        'isolatedViews.annotations.heading': '[Annotations]',
        'isolatedViews.annotations.descriptions': '[Descriptions]',
        'isolatedViews.annotations.dimensions': 'Dimensiynau',
        'isolatedViews.annotations.overlapping': 'Cuddio eitemau sy’n Gorgyffwrdd',

        // maps
        'isolatedViews.maps.heading': 'Map sylfaen',
        'isolatedViews.maps.standard': '[Standard]',
        'isolatedViews.maps.custom': '[Custom]'
    }
};
